export const project_url = "lms";
export const admin_url = "Wbb79TP69dXh";
export const media_url = "/lms/media/";
export const secretPass = "XkhZG4fW2t2W";
export const seo_tag_config = false;
export const content_display_config = false;
